/* eslint-disable react/prop-types */
import React from 'react';
import { Footer } from 'components/theme';
import { IntroAndHeader } from 'components/landing';
import BlogHeader from 'components/blog/BlogHeader';
import { Global, WrapperBody } from './styles';
import './fonts.css';

export const Layout = ({ children, isBlog }) => (
  <>
    <Global />
    {!isBlog && <IntroAndHeader />}
    {isBlog && <BlogHeader />}
    <WrapperBody>{children}</WrapperBody>
    <Footer />
  </>
);
